import React from 'react';
import { Box, GridItem, Image } from '@chakra-ui/react';

const Air = () => {
  return (
    <Box>
      <Box as="h1" fontSize="34px" textTransform="uppercase" mb={5}>
        IN THE AIR
      </Box>
      <GridItem as="p">Application mobile de lecture numérique personnalisée</GridItem>
      <Box as="h1" fontSize="13px" textTransform="uppercase" mb={5} mt={5}>
        [Objectifs]
      </Box>
      <GridItem as="p">– Identifier les usages et attentes autour de la lecture mobile (questionnaires, personas, parcours)</GridItem>
      <GridItem as="p">– Concevoir un prototype fluide, minimaliste et centré sur l’expérience de lecture</GridItem>
      <GridItem as="p">– Intégrer des fonctionnalités clés : profil lecteur vivant, suggestions intelligentes, suivi de rythme, lecture audio et mixte</GridItem>

      <Box as="h1" fontSize="13px" textTransform="uppercase" mb={5} mt={5}>
        [LIENS]
      </Box>
      <Box>
        <a
          href="https://www.figma.com/proto/5oJqh9p1Nx0edwhr2bnjN1/In-the-Air--UX-UI-DESIGN-?page-id=149%3A4274&node-id=393-7722&viewport=4826%2C-3258%2C0.33&t=Kd9NV3VuwR0ykFWc-1&scaling=scale-down&content-scaling=fixed&starting-point-node-id=393%3A7722"
          target="_blank"
          rel="noreferrer"
          style={{ textDecoration: 'underline' }}
        >
          Prototype FIGMA
        </a>
      </Box>
    </Box>
  );
};

export default Air;
